import React, { Component, Suspense, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import Spinner from '../app/shared/Spinner';

const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const Report = lazy(() => import('./report/Report'));
const Analytics = lazy(() => import('./analytics/Analytics'));
const ItemDimensionAnalysis = lazy(() => import('./analytics/ItemDimensionAnalysis'));
const Login = lazy(() => import('./user-pages/Login'));

class AppRoutes extends Component {
  render () {
    return (
      <Suspense fallback={<Spinner/>}>
        <Switch>
          <PrivateRoute exact path="/pages/dashboard" component={Dashboard} />
          <PrivateRoute exact path="/pages/report" component={Report} />
          <PrivateRoute exact path="/pages/analytics" component={Analytics} />
          <PrivateRoute exact path="/pages/itemdimensionanalysis" component={ItemDimensionAnalysis} />
          <Route path="/login" component={Login} />
          <Redirect to="/login" />
        </Switch>
      </Suspense>
    );
  }
}

export default AppRoutes;